// Modify default `options`
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Modify default options, then return them
    options.enterKeyHint = "search";
    options.placeholder = "Search Our Products";
    options.openOnFocus = true;
    return options;
  });

  //------------------------------start-------------------------//
  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    // Modify default options, then return them
    const { html, state } = templateOptions;
    const { query } = state;
    return html``;
  });
  //------------------------------end-------------------------//


  //------------------------------start-top-search-and-right-bar-------------------------//
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections top-search-section">
          ${templateOptions.state.query == '' &&
            html`<div class="aa-PanelSection--center top-search">
            <h2>Top Search</h2>
            ${elements.querySuggestionsPlugin}
            </div>`
          }
          ${templateOptions.state.query != '' &&
            html`<div class="aa-PanelSection--left">
              <div class="aa-SourceHeader">
                  <a href="https://www.monicarichkosann.com/collections/collections" class="aa-SourceHeaderTitle"
                    >${algoliaShopify.translations.collections}</a
                  >
                </div>
              ${elements.collections}
              <div class="aa-SourceHeader">
                  <a href="https://www.monicarichkosann.com/pages/our-story" class="aa-SourceHeaderTitle"
                    >Discover</a
                  >
                </div>
              ${elements.pages}
          </div>
          <div class="aa-PanelSection--right">
              ${elements.products}
            </div>`
          }
          
        </div>
      </div>
    `;
  });
  //------------------------------end-------------------------//


  //------------------------------start-------------------------//
  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;

    // Function to convert <span> to <img> inside the copied content
    function convertSpansToImages(container) {
      const spans = container.querySelectorAll('span[data-src]');

      // Loop through each <span> with a data-src attribute
      spans.forEach(span => {
        const img = document.createElement('img');
        img.src = span.getAttribute('data-src') + '&width=500';
        img.alt = span.getAttribute('alt') || ''; // Set alt attribute if available, else empty
        span.replaceWith(img); // Replace the <span> with the new <img> element
      });
    }

    // Function to copy the content of .listrak-search and convert <span> to <img>
    function copyListrakSearchContent() {
      const listrakSearch = document.querySelector('.listrak-search');
      const searchNoResult = document.querySelector('.search-no-result');
      const panel = document.querySelector('.aa-Panel');

      // Check if .listrak-search exists, and if .aa-Panel doesn't already contain .listrak-search__box elements
      if (listrakSearch && searchNoResult && panel && !panel.querySelector('.listrak-search__box')) {
        // Copy the inner content of .listrak-search
        searchNoResult.innerHTML = listrakSearch.innerHTML;

        // Convert <span> to <img> inside the .search-no-result container
        convertSpansToImages(searchNoResult);
      }
    }

    // Execute content insertion after the hook completes rendering
    setTimeout(copyListrakSearchContent, 0);
  
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <p class="aa-NoResultsHeader">
          Sorry no results found.
        </p>
        <h2 class="list-rec__widget-title">
          <span class="title-text">You May Also Like</span>
        </h2>
        <div class="search-no-result"></div>
      </div>
    `;
  });
  
  //------------------------------end-------------------------//

  
});


  document.addEventListener("algolia.hooks.initialize", function () {
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteProductTemplate",
      function (_defaultTemplate, templateOptions, distinct, itemLink) {
        // Modify default options, then return them
        const { html, item, components } = templateOptions;
        const regex = /<\/?[^>]+(>|$)/g;
        const priceRange = algoliaShopify.helpers.displayPrice(item, distinct);
        const checkRangePrice = priceRange.includes('-');
        const priceProduct = checkRangePrice ? priceRange.split(" - ")[0].replace('.00', '') : priceRange.replace('.00', '');
        const checkSecondTitle = item.meta && item.meta.global && item.meta.global.second_title ? item.meta.global.second_title.replace(regex, ' ') : '';
        const titleProduct = item.title.replace(regex, ' ');

        const link = itemLink = itemLink.replace(/\/$/, '');

        return html`
          <a
            href="${link}"
            class="aa-ItemLink aa-ProductItem"
            onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
          >
            <div class="aa-ItemContent">
              <div class="aa-ItemPicture aa-ItemPicture--loaded">
                <img
                  src="${algoliaShopify.helpers.compactImage(item)}"
                  alt="${titleProduct}"
                />
              </div>
              <div class="aa-ItemContentBody">
                <div class="aa-ItemContentTitleWrapper">
                  <div class="aa-ItemContentTitle">
                  ${titleProduct}
                    <span class="algolia-variant">
                      ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                    </span>
                  </div>
                  <small>${checkSecondTitle}</small>
                </div>
                <div class="aa-ItemContentPrice">
                  <div class="aa-ItemContentPriceCurrent">
                    ${checkRangePrice ? `Starting from ` : ''}
                    <p class="${checkRangePrice ? `start-from-price ` : ''}">${priceProduct}</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        `;
      }
    );
  });
  


//-------------------------------------------------------------------------------------------------------------------------------------------------------
//Instant customize
//-------------------------------------------------------------------------------------------------------------------------------------------------------

document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
      const priceRangeInst = algoliaShopify.helpers.displayPrice(hit, hit._distinct);
      const regex = /<\/?[^>]+(>|$)/g;
      const checkRangePrice = priceRangeInst.includes('-');
      const priceInst = checkRangePrice ? priceRangeInst.split(" - ")[0].replace('.00', '') : priceRangeInst.replace('.00', '');
      const checkSecondTitle = hit.meta && hit.meta.global && hit.meta.global.second_title ? hit.meta.global.second_title.replace(regex, ' ') : '';
      const titleProduct = hit.title.replace(regex, ' ');
  
      return html`
        <div
          class="ais-hit ais-product" 
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
        >
          <img
            class="ais-hit--picture"
            src="${algoliaShopify.helpers.mediumImage(hit)}"
            alt="${titleProduct} - ${hit.variant_title}"
          />
  
          <div class="ais-hit--details">
            <p class="ais-hit--title">
              <a
                data-algolia-index="${hit.index}"
                data-algolia-position="${hit.productPosition}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${hit.objectID}"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                onclick="void(0)"
                title="${algoliaShopify.helpers.fullTitle(
                  titleProduct,
                  hit._distinct,
                  hit.variant_title
                )}"
              >
                ${titleProduct}
              </a>
            </p>
            
            ${checkSecondTitle &&
              html`
                <p
                  class="ais-hit--subtitle"
                  title="${checkSecondTitle}"
                >
                  ${checkSecondTitle}
                </p>
              `}

            <p class="ais-hit--price">
              ${checkRangePrice ? html`<span class="ais-hit--star-from"> Starting from </span> <b>${priceInst}</b>` : html`<b>${priceInst}</b>` }
            </p>
            <!-- Extra info examples - Remove the display: none to show them -->
            <p class="ais-hit--info" style="display: none">
              ${hit.sku &&
                html`
                  <span class="algolia-sku"
                    >${components.Highlight({ attribute: 'sku', hit })}</span
                  >
                `}
              ${hit.barcode &&
                html`
                  <span class="algolia-barcode"
                    >${components.Highlight({ attribute: 'barcode', hit })}</span
                  >
                `}
              ${hit.weight &&
                html`
                  <span class="algolia-weight">${hit.weight}</span>
                `}
              ${!hit.taxable &&
                html`
                  <span class="algolia-taxable"
                    >${algoliaShopify.translations.taxFree}</span
                  >
                `}
            </p>
            <!-- Tags example - Remove the display: none to show them -->
            <p class="ais-hit--tags" style="display: none">
              ${hit?._highlightResult.tags?.map(
                tag =>
                  html`
                    <span class="ais-hit--tag">${tag.value}</span>
                  `
              )}
            </p>
            ${!hit._distinct &&
              html`
                <form
                  id="algolia-add-to-cart-${hit.objectID}"
                  style="display: none;"
                  action="/cart/add"
                  method="post"
                  enctype="multipart/form-data"
                >
                  <input type="hidden" name="id" value="${hit.objectID}" />
                </form>
                <p class="ais-hit--cart">
                  ${hit.can_order
                    ? html`
                        <button
                          class="ais-hit--cart-button"
                          data-form-id="algolia-add-to-cart-${hit.objectID}"
                        >
                          ${algoliaShopify.translations.addToCart}
                        </button>
                      `
                    : html`
                        <button
                          class="ais-hit--cart-button ais-hit--cart-button__disabled"
                        >
                          ${algoliaShopify.translations.outOfStock}
                        </button>
                      `}
                </p>
              `}
          </div>
        </div>
      `;
    });
  });


  document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
      console.log(data);
      return html`
        <div class="ais-page">
          <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
          <div class="ais-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-facets-button">
            Show filters
          </div>
          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map(
              (facet, index) => index === 0
                ? html`
                  <div
                    class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                  >
                    
                    <input
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                    />

                    <label
                      for="${facet.escapedName}"
                      class="ais-range-slider--header ais-facet--header ais-header"
                      >${facet.title}</label
                    >
                    <div
                      class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                    ></div>
                  </div>
                `
                : html`
                  <div
                    class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                  >
                    
                    <input
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                      checked="checked"
                    />
                    <label
                      for="${facet.escapedName}"
                      class="ais-range-slider--header ais-facet--header ais-header"
                      >${facet.title}</label
                    >
                    <div
                      class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                    ></div>
                  </div>
                `
            )}            
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      ${algoliaShopify.translations.sortBy}
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html`
                      ${algoliaShopify.translations.sortBy}
                      ${algoliaShopify.translations.relevance}
                    `}
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
    });
  });
